// FADE IN

(function () {
  var elements;
  var windowHeight;

  function initFade() {
    elements = document.querySelectorAll('.hidden');
    windowHeight = window.innerHeight;
  }

  function checkPositionFade() {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var positionFromTop = elements[i].getBoundingClientRect().top;

      if (positionFromTop - windowHeight <= 100) {
        element.classList.add('fade-in-element');
        element.classList.remove('hidden');
      }
    }
  }

  window.addEventListener('scroll', checkPositionFade, {passive: true});
  window.addEventListener('resize', initFade, {passive: true});

  initFade();
  checkPositionFade();
})();


// IAC ANIMATION

(function () {
  var elements;
  var windowHeight;

  function iacAnimation() {
    elements = document.querySelectorAll('.iac-hidden');
    windowHeight = window.innerHeight;
  }

  function checkPositionFade() {
    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var positionFromTop = elements[i].getBoundingClientRect().top;

      if (positionFromTop - windowHeight <= 100) {
        element.classList.add('iac-running');
        element.classList.remove('iac-hidden');
      }
    }
  }

  window.addEventListener('scroll', checkPositionFade, {passive: true});
  window.addEventListener('resize', iacAnimation, {passive: true});

  iacAnimation();
  checkPositionFade();
})();